// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"ApplicationReviewPage_cancelButton__1cTHG","content":"ApplicationReviewPage_content__IekbJ","formWrapper":"ApplicationReviewPage_formWrapper__18kzG"};